import { put, takeLatest } from 'redux-saga/effects'
import { ADD_SETTING } from '../types/settings.types'
import { settingAdded } from '../actions/settings.actions'

export function* addSetting({ payload: setting }) {
  try {
    yield put(settingAdded(setting))
  } catch (e) {
    console.error(e)
  }
}

export default [takeLatest(ADD_SETTING, addSetting)]
